import { AppModule } from 'app/module';
import { loadScript } from 'util/loadScript';
import Template from './template.hbs';

const SCRIPT_ID = 'captcha';
const RECAPTCHA_CALLBACK = 'googleReCaptchaReady';

export class Captcha extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    load() {
        loadScript(`//www.google.com/recaptcha/api.js?onload=${RECAPTCHA_CALLBACK}&render=explicit`, SCRIPT_ID);

        window.googleReCaptchaReady = () => {
            this.events.emit('ready');
        };
    }

    loaded() {
        return typeof grecaptcha !== 'undefined';
    }

    activate(callback) {
        if (this.dom.el.childNodes.length !== 0) {
            return;
        }

        this.captchaId = grecaptcha.render(this.dom.el, {
            sitekey: RECAPTCHA_PUBLIC_KEY,
            size: 'invisible',
            callback,
        });
    }

    execute() {
        grecaptcha.execute(this.captchaId);
    }

    reset() {
        grecaptcha.reset(this.captchaId);
    }
}
